import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import SideNav from "../../../components/commonComponents/Sidebar/SideNav";
import {
  StyledMainBox,
  StickyTopRowStackSpaceBetween,
} from "../../../components/commonComponents/StyledComponents/styled";
import TableauDash from "../../../components/commonComponents/TableauDashboard/TableauDash";
import { checkUserDetailsFromCookie } from "../../../api_calls/userManagement";
import Grid from "@mui/material/Unstable_Grid2";

import {
  clearfilters,
  fetchCampaignNames,
} from "../../../api_calls/campaignRequests";
import ClipNameFilter from "../../../components/commonComponents/Filters/ClipNameFilter";
import { TextButton } from "../../../components/commonComponents/Buttons/ActionButton";
import { useNavigate } from "react-router-dom";
import { fetchClipNames } from "../../../api_calls/clipRequests";

import {
  formatToStandardDate,
  standardFormatToday,
  getFirstDayTwoMonthsAgo,
  findStoreIds,
  independentStoreListOptions,
  findEmbeddableId,
} from "../../../api_calls/utils";
import StoreFilter from "../../../components/commonComponents/Filters/StoreFilter";
import Dashboard from "../../../components/commonComponents/Embeddable/Dashboard";
import { setBatchLoadingStatus } from "../../../api_calls/requestConfig";
import AccessControl from "../../../components/commonComponents/Hoc/AccessControl";

const OverviewForClip = () => {
  // Variables
  const userStateDate = useSelector((state) => state.userSelections);
  const [userInfo, setUserInfo] = React.useState({});

  const navigate = useNavigate();

  const dashboardVariables = () => {
    let overviewDashboardVariables = {}

    if (typeof userStateDate.embedded_clip_overview_clip_selection !== "undefined" && userStateDate.embedded_clip_overview_clip_selection.length !== 0) {
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        IdClip: userStateDate.embedded_clip_overview_clip_selection,
      }
    }
    if (typeof userStateDate.embedded_clip_overview_stores !== "undefined" && userStateDate.embedded_clip_overview_stores.store_ids.length !== 0) {
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        Stores: userStateDate.embedded_clip_overview_stores.store_ids,
      }
    }

    return overviewDashboardVariables;
  }

  React.useEffect(() => {
    const checkUserDetails = checkUserDetailsFromCookie();

    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);

    const fetchData = async () => {
      setBatchLoadingStatus(true)
      Promise.all([fetchCampaignNames(), fetchClipNames()]).then(() => setBatchLoadingStatus(false))
    };

    fetchData();
    clearfilters();
  }, []);

  // Elements
  return (
    <>
      {typeof userStateDate.campaign_names_info !== "undefined" && typeof userStateDate.clip_names_info !== "undefined" && (
        <StyledMainBox component="main">
          <StickyTopRowStackSpaceBetween direction={"row"} spacing={2}>
            {/* ------- Back to campaigns button ----------- */}
            <Box sx={{ alignContent: "center" }}>
              <TextButton
                onClick={(e) => {
                  // e.preventDefault();
                  navigate("/cb-visuals");
                }}
                label={"Back to Contact-based Visuals"}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
              <Box sx={{ width: 250 }}>
                {/* ------- Clip Name/ clips boolean Filter ----------- */}
                {typeof userStateDate.clip_names_info !== "undefined" && (
                  <ClipNameFilter usedFor={"clips"} reduxKeywordToSaveValue={"embedded_clip_overview_clip_selection"} />
                )}
              </Box>
              <Box sx={{ width: 250 }}>
                {/* ------- Campaign Name Filter ----------- */}
                <StoreFilter
                  usedFor={"overview"}
                  reduxKeywordToSaveValue={"embedded_clip_overview_stores"}
                  fetchListFor="independent"
                />
              </Box>
            </Box>
          </StickyTopRowStackSpaceBetween>
          <Box height={1} />
          <Grid container spacing={2}>
            {typeof userInfo.root_company_id !== "undefined" && userInfo.root_company_id !== "" && typeof userStateDate.stores_list !== "undefined" && (
              <Dashboard
                embedDashboardId={findEmbeddableId("brand_analytics", "clip_overview")}
                variables={dashboardVariables()}
                filterConfig={{
                  "number_root": userInfo.root_company_id.toString(),
                }} />
            )}
          </Grid>
        </StyledMainBox>
      )}
    </>
  );
};

export default AccessControl(OverviewForClip, ["clip_list_can_view", "clip_list_can_edit"], [], ["campaigns_section", "clips"]);
